import { SVGProps } from 'react';

const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M12.667 8.665H3.333V7.332h9.334v1.333Z" />
    </svg>
);
export default SvgMinus;
